module.exports = __webpack_public_path__ + "img/11.8ab8731e.png";